import {
  START_REDIRECT,
  END_REDIRECT,
  PHONE_FIELD_CHANGE,
  TEXT_LINK,
  TEXT_LINK_FAIL,
  TEXT_LINK_SUCCESS,
  SUCCESS_MESSAGE
} from './types';


import API from './API';
const api = API.create();

export const startRedirect = (redirect) => {
  return {
    type: START_REDIRECT,
    payload: redirect
  };
};
export const endRedirect = (redirect) => {
  return {
    type: END_REDIRECT
  };
};

export const phoneFieldChange = (phone) => {
  return {
    type: PHONE_FIELD_CHANGE,
    payload: phone
  };
};


export const textLink = ({ token, phone_number, text }) => {
  return (dispatch) => {
    dispatch({ type: TEXT_LINK });

    api.textLink(token, phone_number, text)
      .then(response => {
        if(response.problem != null){
          textLinkFail(dispatch, response.problem);
        }else if(response.data.error !== false){
          textLinkFail(dispatch, response.data.error);
        } else {
          textLinkSuccess(dispatch);
        }
      });
  };
};

const textLinkFail = (dispatch, error) => {
  dispatch({ type: TEXT_LINK_FAIL, payload: error });
}
const textLinkSuccess = (dispatch) => {

  dispatch({
    type: TEXT_LINK_SUCCESS,
  });

  dispatch({
    type: SUCCESS_MESSAGE,
    payload: "Your link has been texted to you!"
  });
}



// WEBPACK FOOTER //
// ./src/actions/CommonActions.js